import { useEffect, useState } from 'react';
import { useComms } from '../context/CommsContext';
import { createAuthenticatedMediaObjectUrl } from '../matrix/media';

export const useAuthenticatedMedia = (mxc?: string) => {
  const { fetchMediaBlob } = useComms();
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState<{
    url: string | null;
    loading: boolean;
    failed: boolean;
  }>({ url: null, loading: Boolean(mxc), failed: !mxc });

  useEffect(() => {
    let active = true;
    let revoke: () => void = () => undefined;
    if (!mxc) {
      setState({ url: null, loading: false, failed: true });
      return () => undefined;
    }
    setState({ url: null, loading: true, failed: false });
    void createAuthenticatedMediaObjectUrl(fetchMediaBlob, mxc)
      .then((media) => {
        if (!active) {
          media.revoke();
          return;
        }
        revoke = media.revoke;
        setState({ url: media.url, loading: false, failed: false });
      })
      .catch(() => {
        if (active) setState({ url: null, loading: false, failed: true });
      });
    return () => {
      active = false;
      revoke();
    };
  }, [attempt, fetchMediaBlob, mxc]);

  return { ...state, retry: () => setAttempt((current) => current + 1) };
};
